export class FileAttachmentInput {
    FkPageId: number;
    PageName: string;
    TableName: string;
    AutoId: number;
    Flag:string;
}
